export const ingredientsData = [
  {
    index: 0,
    name: "garlic",
    counts: 13,
    foods:[
      "Tteok-bokki",
      "Kimchi",
      "Galbi",
      "Bibimbap",
      "Sundae",
      "Bulgogi",
      "Mandu",
      "Jeon",
      "Kimchi-bokkeum-bap",
      "Kimchi-jjigae",
      "Kal-guksu",
      "Japchae",
      "Budae jjigae"
    ]
  },
  {
    index: 1,
    name: "scallion",
    counts: 12,
    foods:[
      "Tteok-bokki",
      "Kimchi",
      "Galbi",
      "Bibimbap",
      "Sundae",
      "Bulgogi",
      "Mandu",
      "Kimchi-bokkeum-bap",
      "Kimchi-jjigae",
      "Janchi-guksu",
      "Japchae",
      "Budae jjigae"
    ]
  },
  {
    index: 2,
    name: "soy sauce",
    counts: 11,
    foods:[
      "Tteok-bokki",
      "Gimbap",
      "Galbi",
      "Bibimbap",
      "Bulgogi",
      "Mandu",
      "Jeon",
      "Kimchi-bokkeum-bap",
      "Kimchi-jjigae",
      "Kal-guksu",
      "Japchae",
      "Budae jjigae"
    ]
  },
  {
    index: 3,
    name: "onion",
    counts: 9,
  },
  {
    index: 4,
    name: "sesame oil",
    counts: 9,
    foods: [
      "Galbi",
      "Bulgogi",
      "Mandu",
      "Kimchi-bokkeum-bap",
      "Janchi-guksu",
      "Kal-guksu",
      "Japchae",
      "Budae jjigae"
    ]
  },
  {
    index: 5,
    name: "sesame seed",
    counts: 8,
    foods: [
      "Gimbap",
      "Galbi",
      "Bibimbap",
      "Sundae",
      "Bulgogi",
      "Jeon",
      "Janchi-guksu",
      "Japchae"
    ]
  },
  {
    index: 6,
    name: "black pepper",
    counts: 7,
    foods: [
      "Galbi",
      "Jeon",
      "Kimchi-bokkeum-bap",
      "Kimchi-jjigae",
      "Kal-guksu",
      "Japchae",
      "Budae jjigae"
    ]
  },
  {
    index: 7,
    name: "egg",
    counts: 7,
    foods:[
      "Gimbap",
      "Bibimbap",
      "Mandu",
      "Jeon",
      "Gangjeong",
      "Janchi-guksu",
      "Japchae"
    ]
  },
  {
    index: 8,
    name: "vegetable oil",
    counts: 6,
    foods:[
      "Bibimbap",
      "Hotteok",
      "Jeon",
      "Kimchi-bokkeum-bap",
      "Kal-guksu",
      "Japchae"
    ]
  },
  {
    index: 9,
    name: "gochugaru",
    counts: 5,
    foods:[
      "Tteok-bokki",
      "Kimchi",
      "Mandu",
      "Kimchi-jjigae",
      "Budae jjigae"
    ]
  },
  {
    index: 10,
    name: "kimchi",
    counts: 4,
    foods:[
      "Mandu",
      "Kimchi-bokkeum-bap",
      "Kimchi-jjigae",
      "Budae jjigae"
    ]
  },
  {
    index: 11,
    name: "pepper",
    counts: 4,
    foods:[
      "Bibimbap",
      "Sundae",
      "Bulgogi",
      "Mandu",
    ]
  },
  {
    index: 12,
    name: "ginger",
    counts: 4,
    foods:[
      "Galbi",
      "Sundae",
      "Mandu",
      "Kimchi-jjigae",
    ]
  },
  {
    index: 13,
    name: "carrot",
    counts: 4,
    foods:[
      "Gimbap",
      "Bibimbap",
      "Bulgogi",
      "Japchae"
    ]
  },
  {
    index: 14,
    name: "flour",
    counts: 3,
    foods:[
      "Hotteok",
      "Jeon",
      "Kal-guksu",
    ]
  },
  {
    index: 15,
    name: "tofu",
    counts: 3,
    foods:[
      "Mandu",
      "Kimchi-jjigae",
      "Budae jjigae"
    ]
  },
  {
    index: 16,
    name: "beef",
    counts: 3,
    foods:[
      "Bibimbap",
      "Bulgogi",
      "Japchae"
    ]
  },
  {
    index: 17,
    name: "spinach",
    counts: 3,
    foods:[
      "Gimbap",
      "Bibimbap",
      "Japchae",
    ]
  },
  {
    index: 18,
    name: "gochujang",
    counts: 3,
    foods:[
      "Tteok-bokki",
      "Bibimbap",
      "Budae jjigae",
    ]
  },
  {
    index: 19,
    name: "kelp",
    counts: 2,
    foods:[
      "Janchi-guksu",
      "Kal-guksu"
    ]
  },
];
